import { render, staticRenderFns } from "./ajukan-ulang-daftar-bimbingan.vue?vue&type=template&id=1331b8ad"
import script from "./ajukan-ulang-daftar-bimbingan.vue?vue&type=script&lang=js"
export * from "./ajukan-ulang-daftar-bimbingan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports